export { default as GDMInputAdornment } from './GDMInputAdornment';

export type { GDMInputAdornmentComponent, GDMInputAdornmentProps } from './GDMInputAdornment.type';
